import { t } from '@/utils/i18nUtils';

import {
  IconProps,
  AppleIcon,
  FacebookIcon,
  GoogleIcon,
  LineIcon,
  EmailIcon,
  PhoneIcon,
  WeChatIcon,
  QQIcon,
} from '@/components/svg';

import VipOpenAdvanceIcon from '../../../assets/images/vipOpen/video-open__advance-icon.png';
import VipOpenDeviceIcon from '../../../assets/images/vipOpen/video-open__device-icon.png';
import VipOpenExclusiveIcon from '../../../assets/images/vipOpen/video-open__exclusive-icon.png';

import { AccountType } from '@/utils/accountUtils';
import {
  HeaderDearUser,
  UserLoginType,
  HeaderTipEnum,
  Privileges,
  PrivilegesType,
  VipOpenContent,
  ChannelEnum,
  SourceValEnum,
  SourcePageEnum,
  VipOpendTips,
} from '@/types/vipOpenPage';

export const AccountTypeIcon: Record<AccountType, React.FC<IconProps>> = {
  [AccountType.QQ]: QQIcon,
  [AccountType.WeChat]: WeChatIcon,
  [AccountType.Phone]: PhoneIcon,
  [AccountType.Facebook]: FacebookIcon,
  [AccountType.Line]: LineIcon,
  [AccountType.Apple]: AppleIcon,
  [AccountType.Google]: GoogleIcon,
  [AccountType.Email]: EmailIcon,
};

export const headerDearUser: HeaderDearUser = {
  [UserLoginType.NoLogin]: t('vipOpenPage.dear'),
  [UserLoginType.NotVipUser]: t('vipOpenPage.dear'),
  [UserLoginType.VipUser]: t('vipOpenPage.dearVip'),
};
export const headerWelcome = t('vipOpenPage.welcome');

export const headerExpireTime = t('vipOpenPage.expireTime');

export const headerTipEnum: HeaderTipEnum = {
  normal: {
    [UserLoginType.NoLogin]: t('vipOpenPage.noLogin'),
    [UserLoginType.NotVipUser]: t('vipOpenPage.notVipUser'),
    [UserLoginType.VipUser]: t('vipOpenPage.vipUser'),
  },
  astro: {
    [UserLoginType.NoLogin]: t('vipOpenPage.noLoginAstro'),
    [UserLoginType.NotVipUser]: t('vipOpenPage.notVipUserAstro'),
    [UserLoginType.VipUser]: t('vipOpenPage.vipUserAstro'),
  },
};

export const headerBtnText = {
  [UserLoginType.NoLogin]: t('vipOpenPage.loginRightNow'),
  [UserLoginType.NotVipUser]: t('vipOpenPage.switchAccount'),
  [UserLoginType.VipUser]: t('vipOpenPage.switchAccount'),
};

export const privilegesTotal = 3;
export const privilegesTitle = t('vipOpenPage.privilegesTitle');

export const privilegesList: Privileges[] = [
  {
    type: PrivilegesType.Advance,
    icon: VipOpenAdvanceIcon,
    content: t('vipOpenPage.privilegesList_advance'),
  },
  {
    type: PrivilegesType.MoreDevice,
    icon: VipOpenDeviceIcon,
    content: t('vipOpenPage.privilegesList_device'),
  },
  {
    type: PrivilegesType.Exclusive,
    icon: VipOpenExclusiveIcon,
    content: t('vipOpenPage.privilegesList_exclusive'),
  },
];

export const getNewCode = t('vipOpenPage.getNewCode');

export const vipOpenContent: VipOpenContent = {
  [ChannelEnum.Normal]: {
    openVipQrCode: true,
    openVipQrCodeTip: t('vipOpenPage.qrCodeTip'),
  },
  [ChannelEnum.Astro]: {
    AstroPurchaseVipTitle: t('vipOpenPage.AstroPurchaseVipTitle'),
    purchaseVip: t('vipOpenPage.purchaseVip'),
    AstropurchaseVipTip: t('vipOpenPage.AstropurchaseVipTip'),
  },
};

export const sourceValEnum: SourceValEnum = {
  [SourcePageEnum.PlayPage]: '2033',
  [SourcePageEnum.PlayDetailPage]: '2032',
  [SourcePageEnum.HomePage]: '2034',
  [SourcePageEnum.SetUpPage]: '2035',
};

export const vipOpendTips: VipOpendTips = {
  [UserLoginType.NoLogin]: t('vipOpenPage.loginRightNow'),
  [UserLoginType.NotVipUser]: t('vipOpenPage.switchAccountTip'),
  [UserLoginType.VipUser]: t('vipOpenPage.switchAccountTip'),
};
